var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "page-header" },
          [
            _c("h1", { staticClass: "page-title" }, [_vm._v("Campaign")]),
            _c("breadcrumb", {
              attrs: {
                name: "WSGT_DRIVE_PROGRESS_UPLOAD",
                withLast: _vm.campaign.name,
              },
              on: {
                "update:withLast": function ($event) {
                  return _vm.$set(_vm.campaign, "name", $event)
                },
                "update:with-last": function ($event) {
                  return _vm.$set(_vm.campaign, "name", $event)
                },
              },
            }),
            _c("div", { staticClass: "page-header-actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-round btn-default mx-10",
                  attrs: { type: "button" },
                  on: { click: _vm.goBack },
                },
                [
                  _c("i", {
                    staticClass: "icon md-chevron-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" Back "),
                ]
              ),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "page-content page-content-table" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _vm.info
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("strong", [_vm._v("Campaign ID:")]),
                            _vm._v(" " + _vm._s(_vm.campaign.id) + " "),
                          ]),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("strong", [_vm._v("No. WS:")]),
                            _vm._v(" " + _vm._s(_vm.info.count_ws) + " "),
                          ]),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("strong", [_vm._v("No. GT:")]),
                            _vm._v(" " + _vm._s(_vm.info.count_gt) + " "),
                          ]),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("strong", [_vm._v("Status:")]),
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.info.status.toUpperCase()) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("strong", [_vm._v("Last Update:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(_vm.info.last_upload)) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "panel" }, [
              _c(
                "div",
                { staticClass: "panel-body p-0" },
                [
                  _c("div", { staticClass: "row p-4" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.isUploading,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showImportModal = true
                                  },
                                },
                              },
                              [
                                _vm.isUploading
                                  ? _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isUploading
                                        ? "Processing..."
                                        : "Import Progress"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.downloadExample.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v(" Click to download example ")]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn",
                                attrs: { type: "button" },
                                on: { click: _vm.exportToExcel },
                              },
                              [
                                _c("i", { staticClass: "fa fa-file-excel-o" }),
                                _vm._v(" Export to Excel "),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm.datatable && _vm.columns.length > 0
                    ? _c("vue-good-table", {
                        ref: "table",
                        attrs: {
                          mode: "remote",
                          columns: _vm.columns,
                          rows: _vm.datatable.data,
                          totalRows: _vm.datatable.total_records,
                          isLoading: _vm.isUploading,
                          "pagination-options": {
                            enabled: true,
                            mode: "records",
                            perPage: 10,
                            perPageDropdown: [10, 20, 50, 100],
                            dropdownAllowAll: false,
                            setCurrentPage: 1,
                            nextLabel: "Next",
                            prevLabel: "Prev",
                            rowsPerPageLabel: "Rows per page",
                            ofLabel: "of",
                            allLabel: "All",
                          },
                          "search-options": {
                            enabled: true,
                            placeholder: "Search...",
                            trigger: "enter",
                          },
                          "sort-options": {
                            enabled: true,
                            initialSortBy: {
                              field: "ws_isms_code",
                              type: "asc",
                            },
                          },
                          styleClass: "vgt-table striped",
                        },
                        on: {
                          "on-search": _vm.onSearch,
                          "on-sort-change": _vm.onSortChange,
                          "on-page-change": _vm.onPageChange,
                          "on-per-page-change": _vm.onPerPageChange,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-row",
                              fn: function (props) {
                                return [
                                  props.column.field === "gt_shop_tel"
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatPhoneNumber(
                                                props.formattedRow[
                                                  props.column.field
                                                ]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : props.column.field.startsWith("month")
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ] || "-"
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ] || "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          100230516
                        ),
                      })
                    : !_vm.datatable || _vm.isUploading
                    ? _c(
                        "div",
                        { staticClass: "text-center py-50" },
                        [
                          _c("loader"),
                          _vm.isUploading
                            ? _c("p", { staticClass: "mt-3" }, [
                                _vm._v(
                                  " Processing uploaded data... Please wait. "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "text-center py-50" }, [
                        _c("p", [_vm._v("No data available")]),
                      ]),
                ],
                1
              ),
            ]),
            _vm.showImportModal
              ? _c(
                  "div",
                  {
                    staticClass: "modal fade show",
                    staticStyle: {
                      display: "block",
                      "background-color": "rgba(0, 0, 0, 0.5)",
                    },
                  },
                  [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h4", { staticClass: "modal-title" }, [
                            _vm._v("Import Progress"),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: { click: _vm.closeImportModal },
                            },
                            [_c("span", [_vm._v("×")])]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "modal-body" },
                          [
                            _vm._m(0),
                            _c("file-upload", {
                              attrs: {
                                accept: ".xlsx,.xls",
                                "max-size": 10485760,
                              },
                              on: {
                                change: _vm.onFileChange,
                                remove: _vm.onFileRemove,
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default",
                              attrs: { type: "button" },
                              on: { click: _vm.closeImportModal },
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled: !_vm.importFile,
                              },
                              on: { click: _vm.importProgress },
                            },
                            [_vm._v(" Import ")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("h5", [_vm._v("This will overwrite existing data.")]),
      _c("p", [_vm._v("Before committing, must check:")]),
      _c("ul", [
        _c("li", [_vm._v("No duplicate WS in many ONGOING campaigns")]),
        _c("li", [_vm._v("No duplicate GT-WS in the same file.")]),
        _c("li", [_vm._v("Validate data for each column")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }